import { render, staticRenderFns } from "./liveBarCodeModel.vue?vue&type=template&id=16afc9e6&scoped=true"
import script from "./liveBarCodeModel.vue?vue&type=script&lang=js"
export * from "./liveBarCodeModel.vue?vue&type=script&lang=js"
import style0 from "./liveBarCodeModel.vue?vue&type=style&index=0&id=16afc9e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16afc9e6",
  null
  
)

export default component.exports